import { fmt } from '../../i18n'
import type { CafeStats } from '../../realtime/protocol'
import { useLocale } from '../use-locale'

/** 入店している人数、集中している人数、今日の星。店先に出ている数字 */
export function LiveStats({ stats }: { stats: CafeStats | null }) {
  const { t } = useLocale()
  if (!stats) return null
  return (
    <aside className="live" aria-label={t.cafe.menuTitle}>
      <dl className="live__stats">
        <div className="live__stat">
          <dt>{t.lp.livePresent}</dt>
          <dd>{stats.present}</dd>
        </div>
        <div className="live__stat">
          <dt>{t.lp.liveFocusing}</dt>
          <dd>
            <span className="live__dot" aria-hidden="true" />
            {stats.focusing}
          </dd>
        </div>
        <div className="live__stat">
          <dt>{t.cafe.starsCount}</dt>
          <dd>{stats.stars}</dd>
        </div>
      </dl>
      <p className="live__note">
        {stats.focusing > 0 ? fmt(t.lp.liveNow, { n: stats.focusing }) : t.lp.liveQuiet}
      </p>
    </aside>
  )
}
